import React, { useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { toggleSlidePanel } from '../../actions';
import SlideViewer from './SlideViewer';
import './slide-panel.css';
// カードの最小サイズ / 下部ツールバーとの余白
const MIN_W = 240;
const MIN_H = 160;
const TOOLBAR_GAP = 88;
const EDGE_GAP = 16;
/**
 * 左下を初期位置に、画面幅の約1/4サイズのカード矩形を返す。
 *
 * @returns {Rect}
 */
function getInitialRect() {
    const vw = typeof window === 'undefined' ? 1280 : window.innerWidth;
    const vh = typeof window === 'undefined' ? 720 : window.innerHeight;
    const w = Math.max(MIN_W, Math.round(vw * 0.25));
    const h = Math.round(w * 0.72) + 44;
    return {
        x: EDGE_GAP,
        y: Math.max(EDGE_GAP, vh - h - TOOLBAR_GAP),
        w,
        h
    };
}
const SLIDE_ICON = (React.createElement("svg", { fill: 'none', height: '18', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', viewBox: '0 0 24 24', width: '18' },
    React.createElement("rect", { height: '14', rx: '2', ry: '2', width: '18', x: '3', y: '3' }),
    React.createElement("line", { x1: '3', x2: '21', y1: '8', y2: '8' }),
    React.createElement("line", { x1: '12', x2: '12', y1: '17', y2: '21' }),
    React.createElement("line", { x1: '8', x2: '16', y1: '21', y2: '21' })));
const DL_ICON = (React.createElement("svg", { fill: 'none', height: '15', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', viewBox: '0 0 24 24', width: '15' },
    React.createElement("path", { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' }),
    React.createElement("polyline", { points: '7 10 12 15 17 10' }),
    React.createElement("line", { x1: '12', x2: '12', y1: '15', y2: '3' })));
function SlidePanel({ _visible, _url, dispatch }) {
    const [rect, setRect] = useState(getInitialRect);
    const rectRef = useRef(rect);
    rectRef.current = rect;
    // ヘッダーを掴んでカードを移動
    const onDragPointerDown = useCallback((e) => {
        if (e.target.closest('.slide-card__close')) {
            return;
        }
        e.preventDefault();
        const startX = e.clientX;
        const startY = e.clientY;
        const { x, y } = rectRef.current;
        const move = (ev) => {
            const maxX = window.innerWidth - rectRef.current.w - EDGE_GAP;
            const maxY = window.innerHeight - rectRef.current.h - EDGE_GAP;
            setRect(r => ({
                ...r,
                x: Math.min(Math.max(EDGE_GAP, x + (ev.clientX - startX)), Math.max(EDGE_GAP, maxX)),
                y: Math.min(Math.max(EDGE_GAP, y + (ev.clientY - startY)), Math.max(EDGE_GAP, maxY))
            }));
        };
        const up = () => {
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', up);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
    }, []);
    // 右下グリップでリサイズ
    const onResizePointerDown = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        const startX = e.clientX;
        const startY = e.clientY;
        const { w, h } = rectRef.current;
        const move = (ev) => {
            setRect(r => ({
                ...r,
                w: Math.max(MIN_W, Math.min(w + (ev.clientX - startX), window.innerWidth - r.x - EDGE_GAP)),
                h: Math.max(MIN_H, Math.min(h + (ev.clientY - startY), window.innerHeight - r.y - EDGE_GAP))
            }));
        };
        const up = () => {
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', up);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `slide-card ${_visible ? 'slide-card--open' : ''}`, style: { left: rect.x, top: rect.y, width: rect.w, height: rect.h } },
            React.createElement("div", { className: 'slide-card__header', onPointerDown: onDragPointerDown },
                React.createElement("span", { className: 'slide-card__title' },
                    SLIDE_ICON,
                    React.createElement("span", null, "\u30B9\u30E9\u30A4\u30C9")),
                React.createElement("span", { className: 'slide-card__actions' },
                    _url && (React.createElement("a", { className: 'slide-card__btn', download: '', href: _url, onPointerDown: e => e.stopPropagation(), rel: 'noopener noreferrer', target: '_blank', title: '\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9' }, DL_ICON)),
                    React.createElement("button", { className: 'slide-card__btn slide-card__close', onClick: () => dispatch(toggleSlidePanel()), title: '\u9589\u3058\u308B' }, "\u2715"))),
            React.createElement("div", { className: 'slide-card__body' }, _visible && _url && (React.createElement(SlideViewer, { height: '100%', pdfUrl: _url, width: '100%' }))),
            React.createElement("div", { className: 'slide-card__resize', onPointerDown: onResizePointerDown }))));
}
function _mapStateToProps(state) {
    return {
        _visible: state['features/slide-view']?.visible ?? false,
        _url: state['features/slide-view']?.url ?? ''
    };
}
export default translate(connect(_mapStateToProps)(SlidePanel));
